import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Menu, LogOut, User } from 'lucide-react'
import { motion, AnimatePresence } from 'framer-motion'
import { useAuth } from '@/hooks/useAuth'
import { AdminMobileNav } from './AdminMobileNav'
import { usePageHeader } from '@/contexts/PageHeaderContext'

export function AdminHeader() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isProfileOpen, setIsProfileOpen] = useState(false)
  const { user, signOut } = useAuth()
  const { headerContent } = usePageHeader()

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-secondary-200">
      <div className="flex items-center h-16 px-4 lg:px-6 gap-4">
        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(true)}
          className="lg:hidden p-2 text-secondary-600 hover:text-secondary-900 flex-shrink-0"
        >
          <Menu className="w-6 h-6" />
        </button>

        {/* Mobile Logo */}
        <Link to="/admin" className="lg:hidden flex items-center gap-2 flex-shrink-0">
          <img
            src="/images/logo.png"
            alt="EngiMarineX"
            className="h-12 w-auto"
          />
        </Link>

        {/* Page Header Content - injected by pages */}
        <div className="flex-1 min-w-0 hidden lg:block">
          {headerContent}
        </div>

        {/* Profile Dropdown */}
        <div className="relative">
          <button
            onClick={() => setIsProfileOpen(!isProfileOpen)}
            className="flex items-center gap-3 p-2 rounded-lg hover:bg-secondary-50 transition-colors"
          >
            <div className="w-8 h-8 bg-primary-100 text-primary-600 rounded-full flex items-center justify-center">
              <User className="w-4 h-4" />
            </div>
            <span className="hidden sm:block text-sm font-medium text-secondary-700">
              {user?.email}
            </span>
          </button>

          <AnimatePresence>
            {isProfileOpen && (
              <>
                <div
                  className="fixed inset-0 z-40"
                  onClick={() => setIsProfileOpen(false)}
                />
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  className="absolute right-0 top-full mt-2 w-56 bg-white rounded-lg shadow-lg border border-secondary-200 py-2 z-50"
                >
                  <div className="px-4 py-2 border-b border-secondary-100">
                    <p className="text-sm font-medium text-secondary-900">
                      {user?.email}
                    </p>
                    <p className="text-xs text-secondary-500">Administrator</p>
                  </div>
                  <button
                    onClick={() => {
                      setIsProfileOpen(false)
                      signOut()
                    }}
                    className="w-full flex items-center gap-3 px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                  >
                    <LogOut className="w-4 h-4" />
                    Sign Out
                  </button>
                </motion.div>
              </>
            )}
          </AnimatePresence>
        </div>
      </div>

      {/* Mobile Navigation */}
      <AdminMobileNav
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
      />
    </header>
  )
}
